<template>
  <div class="mv-page">
    <div class="content-scroll">
      <!-- ── 顶部说明 ───────────────────────────── -->
      <div class="card head-card">
        <h1>聊天动作图鉴</h1>
        <p class="lead">
          在聊天框输入 <code>~</code> 加别名即可做出动作，例如 <code>~大笑</code>、<code>~daxiao</code>、<code>~laugh</code> 效果一样；
          想指定对象就再跟一个空格和对方昵称，例如 <code>~大笑 wang</code>。
        </p>
        <div class="roles">
          <label>预览用我的名字 <input v-model="meName" maxlength="12" /></label>
          <label>对方名字 <input v-model="targetName" maxlength="12" /></label>
          <span class="tip">只影响下面的预览，不影响游戏</span>
        </div>
        <div class="legend">
          <span><i style="background:#ff8800"></i>发起者 / 你自己</span>
          <span><i style="background:#0088ff"></i>被指定的对象</span>
          <span><i style="background:#888888"></i>旁观者视角的叙述</span>
        </div>
      </div>

      <!-- ── 搜索 + 列表（与游戏内弹窗共用同一组件）── -->
      <chat-movement-list :me-name="meName" :target-name="targetName" />
    </div>

    <!-- ── 底部固定区 ─────────────────────────── -->
    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{ name: 'guideIndex' }">← 返回旅游指南</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br />适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ChatMovementList from '../components/chatMovement/ChatMovementList.vue'

  const DEFAULT_ME = '星尘'
  const DEFAULT_TARGET = 'wang'

  export default {
    components: { ChatMovementList },
    data() {
      return {
        meName: DEFAULT_ME,
        targetName: DEFAULT_TARGET
      }
    }
  }
</script>

<style scoped>
.mv-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
}

/* ── 顶部说明 ── */
.head-card {
  padding: 22px 24px 18px;
}

.head-card h1 {
  margin: 0 0 10px;
  font-size: 20px;
  letter-spacing: 0.5px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.lead {
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.85;
  color: #606266;
}

.lead:last-of-type {
  margin-bottom: 0;
}

.lead b {
  color: #409eff;
}

.lead code {
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 1px 5px;
  font-family: Consolas, Menlo, monospace;
  font-size: 12px;
  color: #b5610a;
}

.roles {
  margin-top: 14px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #606266;
}

.roles label {
  display: flex;
  align-items: center;
  gap: 5px;
}

.roles input {
  width: 88px;
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 12px;
  color: #303133;
  background: #fff;
  outline: none;
}

.roles input:focus {
  border-color: #409eff;
}

.roles .tip {
  color: #c0c4cc;
  margin-left: auto;
  font-size: 11px;
}

.legend {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  color: #909399;
}

.legend i {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: middle;
}

/* ── 底部固定区 ── */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ── 响应式 ── */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .head-card {
    padding: 16px 16px 14px;
  }

  .head-card h1 {
    font-size: 18px;
  }

  .roles .tip {
    margin-left: 0;
    width: 100%;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
